import type { IModuleRepository } from "@/application/ports/repositories";
import type { ModuleEntitlement } from "@/domain/modules";
import { apiClient } from "../client";

export class ModuleRepository implements IModuleRepository {
  async getEntitlements(): Promise<ModuleEntitlement[]> {
    const response = await apiClient.get<ModuleEntitlement[]>("/modules/entitlements");
    return response.data;
  }
}
